const settings = {
    logo: "Mizaem",
    logo_description: "Удобно получить займ в Украине",
    footer_text: " - Удобный подбор займов в Украине, 2020",
    title: "Mizaem - Удобный подбор займов в Украине",
    loan_value: "15000",

    lending_url: "https://mizaem.com.ua/",
    lending_name: "Mizaem.com.ua",

    favicon: "../logo/mizaem-small-logo.png",
    logo_img: "../logo/mizaem-small-logo.png",

    primary_color: "#009688",
    secondary_color: "#009688",
    anchor_color: "#2196F3",
    spinner_color: "#BDBDBD",

    gtm: "GTM-N8PHGJR",

    yandex_metrika: "55483816",

    is_phone_required: true,
    is_email_required: false,
    is_surname_required: false,
    is_name_required: false,
    is_passport_required: false,
    is_password_required: false,

    default_password : "cFe4pmdcocyGeT7SdCpQsyLVs",

    skip_3_step: false,

    is_mailgun_ok: true,
    show_i_need: true,

    show_slider: false,
    default_possibility: 15,
    min_default_possibility: 12,
    max_default_possibility: 20,
    default_loanvalue: 3000,
    min_default_loanvalue: 1000,
    max_default_loanvalue: 40000,
    step: 10000,

    social_providers: [],
    show_additional_slogan: false,

    contact_email: "",

    enable_ads_reg: false,
    ads_reg_settings: {
        class: "",
        style: "",
        data_ad_client: "",
        data_ad_slot: "",
        data_ad_format: "",
        data_full_width_responsive: "",
    },

    enable_ads_offers: false,
    ads_offers_settings: {
        placement: "",
        class: "",
        style: "",
        data_ad_client: "",
        data_ad_slot: "",
        data_ad_format: "",
        data_ad_layout_key: "",
    },

    enable_second_ads_offers: false,
    second_ads_offers_settings: {
        class: "",
        style: "",
        data_ad_client: "",
        data_ad_slot: "",
        data_ad_format: "",
        data_full_width_responsive: "",
    },

    payments: {
        enabled: false,
        registration: false,
        pass_registration: false,
        offer: false,
        subscription_confirm: true,
        subscription_confirm_required: true,

        registration_possibility: "",
        registration_help_text: "",
        offer_help_text: "",
        after_check_requisites: false,
    },
};

export default settings;
